import { Permission } from "../types";
import { useActiveSession } from "./useActiveSession";

export function usePermission(permission: Permission) {
  const { session } = useActiveSession();
  return session.permissions.includes(permission);
}
